import { For, Show, useContext } from 'solid-js';
import { Feature } from '../product-types';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { Heading } from '../../../ui-components/heading/heading';
import { Text } from '../../../ui-components/text/text';
import decodeHtmlEntities from '../../../tools/decode-html-entities';

type ProductDescriptionProps = {
    subTitle: string;
    longDescription: string;
    features: Feature[];
};

export const ProductDescription = (props: ProductDescriptionProps) => {
    const { localize } = useContext(AppContext);

    return (
        <div class="flex flex-col gap-cvi-6">
            <Show when={props.subTitle}>
                <div class="tablet-original:pt-cvi-10">
                    <Heading tag="h2" variant="heading-2xl" noBlockSpacing>
                        {props.subTitle}
                    </Heading>
                </div>
            </Show>

            <Text fontSize="body-md" splitParagraph={true} noBlockSpacing>
                {props.longDescription}
            </Text>

            <Show when={props.features && props.features.length > 0}>
                <Heading tag="h3" variant="heading-xl" class="pt-cvi-10" noBlockSpacing>
                    {localize('key-features', 'Key Features')}
                </Heading>
                {/* DS ".list style" (Figma 173:10755): a ds-space(9) dot slot with a brand dot
                    beside heading-md medium copy, ds-gap(5) between items. */}
                <ul class="m-0 flex list-none flex-col gap-cvi-5 p-0">
                    <For each={props.features}>{(feature: Feature) => (
                        <li class="flex items-start">
                            <span class="flex size-cvi-9 shrink-0 items-center justify-center" aria-hidden="true">
                                <span class="block size-cvi-3 rounded-cvi-round bg-cvi-bg-brand" />
                            </span>
                            <span class="min-w-0 flex-1 pt-cvi-4 heading-md font-cvi-medium text-cvi-fg-default">
                                {decodeHtmlEntities(feature?.text ?? '')}
                            </span>
                        </li>
                    )}</For>
                </ul>
            </Show>
        </div>
    );
};
